import React from 'react';
import PropTypes from 'prop-types';

import FormBuilderHelper from '../formBuilderHelper';

import dataModel from '../../../../models/DataModel';
import ComboBox from '../../../ComboBox';

import DragDropIcon from '../../../../assets/images/drag-and-drop-icon.svg';
import TrashIcon from '../../../../assets/images/trash.svg';
import './FormBuilderField.scss';
import Input from '../../../Input';

export default class FormBuilderField extends React.Component {

  constructor(props) {
    super(props);
    FormBuilderField.propTypes = {
      /** Seed object for the field, at least an id is required (use negative for placeholder) */
      field: PropTypes.object.isRequired,
      /** Delete callback */
      handleDeleteField: PropTypes.func,
      /** Callback to mark the form/cs as incomplete if an edit is made to remove required data */
      handleMarkInvalid: PropTypes.func,
      /** sends the whole field back to the parent form - only called if the field is valid/complete */
      handleSaveField: PropTypes.func,
      hasDragDrop: PropTypes.bool,
      
      /** Drag-drop handlers */
      handleDragging: PropTypes.func,
      handleDropping: PropTypes.func,
      handleDragCancel: PropTypes.func,
    };

    this.state = {
      fieldLabel: props.field.prompt,
      fieldOptions: FormBuilderHelper.getOptionsStringFromFieldConfig(props.field), //only used if fieldType == multiple_choice
      fieldType: props.field.field_type,
    };

    // options for the field type dropdown
    this.fieldTypes = [
      { type: 'multiple_choice', name: 'Multiple Choice' },
      { type: 'numeric', name: 'Number Entry' },
      { type: 'text', name: 'Text Entry' },
      { type: 'yes_no', name: 'Yes/No' },
    ];
    this.handleDeleteField = this.handleDeleteField.bind(this);
    this.handleLabelChange = this.handleLabelChange.bind(this);
    this.handleOptionsChange = this.handleOptionsChange.bind(this);
    this.handleTypeSelection = this.handleTypeSelection.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.fixupMouse = this.fixupMouse.bind(this);
    this.handlePrepareDrag = this.handlePrepareDrag.bind(this);
    this.handleStartDrag = this.handleStartDrag.bind(this);
    this.handleDragging = this.handleDragging.bind(this);
    this.handleEndDragging = this.handleEndDragging.bind(this);
  }

  handleDeleteField() {
    const { field, handleDeleteField } = this.props;
    if (field.response && field.response.length) {
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'Are you sure you want to delete this field? Work has begun and this action cannot be undone.',
        cancelButtonText: 'CANCEL',
        okButtonText: 'YES',
        height: 184,
        width: 320,
        handleOwnerOk: () =>  {
          if (handleDeleteField) {
            handleDeleteField(field.id);
          }
        },
      });
    }
    else if (handleDeleteField) {
      handleDeleteField(field.id);
    }
  }
  
  // called when the 'field label' text input changes
  handleLabelChange(e) {
    const newValue = e.target.value;
    this.setState({ fieldLabel: newValue }, () => this.saveFieldIfValid());
  }

  // called when the 'options' text input for multiple choice fields changes
  handleOptionsChange(e) {
    const newValue = e.target.value;
    this.setState({ fieldOptions: newValue }, () => this.saveFieldIfValid());
  }

  // called when the 'field type' dropdown value changes
  handleTypeSelection(selectedType) {
    this.setState({ fieldType: selectedType }, () => this.saveFieldIfValid());
  }

  saveFieldIfValid() {
    const { handleSaveField, handleMarkInvalid, field } = this.props;
    const { fieldType, fieldLabel, fieldOptions } = this.state;
    let fieldOptionsNormalized = fieldOptions;
    if (fieldOptions) {
      // fieldOptionsNormalized = fieldOptions.replace(/,\s*$/, "")
    }
    if (FormBuilderHelper.isFormFieldValid(fieldType, fieldLabel, fieldOptionsNormalized)) {
      // TODO: order
      const newData = {
        prompt: fieldLabel,
        field_type: fieldType,
        config: FormBuilderHelper.getFieldConfigFromOptionsString(fieldType, fieldOptionsNormalized),
      };
      const newField = Object.assign({}, field, newData);
      if (handleSaveField) handleSaveField(newField);
    }
    else {
      if (handleMarkInvalid) handleMarkInvalid(field.id);
    }
  }

  render() {
    const { fieldLabel, fieldOptions, fieldType } = this.state;
    const { hasDragDrop } = this.props;
    const selectedType = this.fieldTypes.find(typeObject => typeObject.type == fieldType);

    let formattedFieldOptions = fieldOptions;
    if (fieldOptions) {
      formattedFieldOptions = formattedFieldOptions.replace(/(\S),(\S)/g, '$1,$2').replace(/,\s+,/g, ',');
    }
    
    return (
      <div className="form-builder-field" ref={el => this.ref = el} id={this.props.id} >

        <div className="form-builder-field__first-line">
          {
            hasDragDrop && 
            <div className="drag-drop-handle"
              onMouseDown={this.handleMouseDown}
              onMouseUp={this.handleMouseUp}
              onMouseMove={this.handleMouseMove}
              src={DragDropIcon}
              alt={'drag to reorder'}
            />
          }
          <label className="label label-label" htmlFor="field-label-input">
            FIELD LABEL
            <Input 
              id={'field-label-input-' + this.props.id}
              autoFocus = {true}
              className="label-input" 
              value={fieldLabel || ''}
              onChange={this.handleLabelChange} 
              placeholder={'Enter a Field Label'} 
            />
          </label>
          <label className="label type-label" htmlFor="formFieldTypePicker">
            FIELD TYPE
            <ComboBox 
              adjustHeight={true}
              currentOption={selectedType}
              defaultText="--Select Type--"
              handleSelection={this.handleTypeSelection}
              hasBorder={false} 
              id="formFieldTypePicker"
              options={this.fieldTypes} 
              underlined={false} 
              width={164}
              noFocus={true}
            />
          </label>
          <img className="remove-button" src={TrashIcon} onClick={ this.handleDeleteField } alt="remove-button" />
        </div>
        {
          fieldType == 'multiple_choice' &&
          <div className='form-builder-field__options'>
            <label className='label' htmlFor="field-options-input">
              OPTIONS
              <Input 
                id="field-options-input"
                className="options-input" 
                value={formattedFieldOptions || ''}
                onChange={this.handleOptionsChange} 
                placeholder={'Enter options seperated with a comma, e.g. "Denver, Boulder, Golden"'} 
              />
            </label>
          </div>
        }
      </div>
    );
  }

  /** DRAG&DROP FUNCTIONS */
  fixupMouse(event) {
    event = event || window.event;
    var e = {
      event: event,
      target: event.target ? event.target : event.srcElement,
      which: event.which ? event.which :
        event.button >= 0 ?
          event.button == 1 ? 1 :
            event.button == 2 ? 3 :
              event.button == 4 ? 2 : 1 :
          event.buttons,
      clientX: event.x ? event.x : event.clientX,
      clientY: event.y ? event.y : event.clientY,
    };
    return e;
  }

  handlePrepareDrag(xPos, yPos) {
    this.dragElement = this.ref;
    this.startX = xPos;
    this.startY = yPos;
  }

  handleStartDrag(element) {
    if (
      !this.dragging &&
      this.dragElement &&
      this.dragElement == element &&
      !this.dragObject
    ) {
      this.dragging = true;
      let bodyElement = document.body;
      // if (this.props.dragParentId) {
      //   bodyElement = document.getElementById(this.props.dragParentId)
      // }
      this.dragObject = element.cloneNode(true);
      this.dragObject.style.position = 'absolute';
      this.dragObject.style.transform = 'rotate(-10deg)';
      this.dragObject.style.zIndex = 9999999;
      this.dragObject.style.opacity = 0.8;
      const bodyRect = bodyElement.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      this.xPos = elementRect.left - bodyRect.left;
      this.yPos = elementRect.top - bodyRect.top;
      this.yOffset = this.startY - this.yPos;
      this.dragObject.style.top = this.yPos + 'px';
      this.dragObject.style.left = this.xPos + 'px';
      bodyElement.addEventListener('mousemove', this.handleDragging);
      bodyElement.addEventListener('mouseup', this.handleEndDragging);
      bodyElement.appendChild(this.dragObject);
    }
  }

  handleDragging(e) {
    let top = e.clientY - this.yOffset;

    if (this.dragObject) {
      this.dragObject.style.top = top + 'px';
      if (this.props.handleDragging) {
        this.props.handleDragging(this.props.field, this.xPos, top);
      }
    }
  }

  handleEndDragging(e) {
    this.dragging = false;
    let bodyElement = document.body;
    bodyElement.removeEventListener('mousemove', this.handleDragging);
    bodyElement.removeEventListener('mouseup', this.handleEndDragging);
    bodyElement.removeChild(this.dragObject);
    this.dragElement = null;
    if (this.props.handleDropping) {
      this.dragObject = null;
      let top = e.clientY - this.yOffset;
      this.props.handleDropping(this.props.field, this.xPos, top);
    }
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    if (e.which == 1) {
      if (this.props.handleDragging) {
        this.handlePrepareDrag(e.clientX, e.clientY);
        document.body.classList.add('no-select');
      }
    }
  }

  handleMouseUp(e) {
    this.dragElement = null;
    document.body.classList.remove('no-select');
  }

  handleMouseMove(e) {
    e = this.fixupMouse(e);
    if (this.props.handleDragging) {
      if (!this.dragging && e.which == 1) {
        if (
          (this.startX && Math.abs(this.startX - e.clientX) > 5) ||
          (this.startY && Math.abs(this.startY - e.clientY) > 5)
        ) {
          this.handleStartDrag(this.ref);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Forms/FormBuilder/FormBuilderField/index.js